module.exports = __webpack_public_path__ + "img/startConfigurationEarrings@2x.6f51490.png";